const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const UKRAINE_PHONE_REGEX = /^\+380\d+$/
/**
 * E.164-style: leading + and one or more digits (e.g. +380501112233).
 */
export const PHONE_WITH_PLUS_REGEX = /^\+\d+$/

export function isValidEmailOrUkrainePhone(value: string): boolean {
    const trimmed = value.trim()
    return EMAIL_REGEX.test(trimmed) || UKRAINE_PHONE_REGEX.test(trimmed)
}

export function isValidEmail(value: string): boolean {
    return EMAIL_REGEX.test(value.trim())
}

export function isValidPhoneWithPlus(value: string): boolean {
    return PHONE_WITH_PLUS_REGEX.test(value.trim())
}

/** Canonical phone for API/storage: leading `+` + digits only. Blank → empty string. */
export function formatPhoneWithPlus(phone: string | null | undefined): string {
    if (phone == null) {
        return ''
    }
    const digits = phone.replace(/\D/g, '')
    if (!digits) {
        return ''
    }
    return `+${digits}`
}
